// Blindagem contra o Google Tradutor do navegador: ele embrulha nós de texto em <font>,
// e quando o React tenta remover/inserir esses nós estoura "Failed to execute
// 'removeChild'/'insertBefore' on 'Node'" e derruba o app. Aqui o DOM passa a tolerar
// nós cujo pai o tradutor trocou. Ref.: facebook/react#11538.
export function blindarContraTradutor() {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removerFilhoTolerante(filho) {
    return filho.parentNode === this ? removeChild.call(this, filho) : filho;
  };

  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function inserirAntesTolerante(novo, referencia) {
    return referencia && referencia.parentNode !== this ? novo : insertBefore.call(this, novo, referencia);
  };
}
